import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap: LocalizedString = {
	[Locale.cs]: "/poptavka",
	[Locale.en]: "/inquiry",
	[Locale.sk]: "/dopyt",
};

export function getInquiryPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
